<template>
  <div class="hello">

    <div class="home-first" style="margin-top: 5em">
      <div class="w3-center" style="color: #4A61DD;">
        INTRODUCING PLANAR
      </div>
      <div class="w3-center title-1" style="">
        The issue tracking tool you'll enjoy using
      </div>
      <p class="w3-center title-2">
        Planar helps streamline software projects, sprints, tasks, and bug tracking. It's built for high-performance teams.
        <br><br>
      </p>

      <center>
        <div class="signup-btn w3-padding-large w3-round">
          <router-link :to="{ name: 'signup' }" class="">
            Sign up for free <i class="fa fa-arrow-right"></i>
          </router-link>
        </div>
      </center>

      <br><br>

      <div class="w3-padding w3-center">
        <img class="w3-centerx main-image" alt="" src="@/assets/img/hero-image.png" style="width: 55em">
      </div>
    </div>

    <br/>

    <div class="w3-center" style="font-weight: bold;margin: 0 auto;max-width: 700px;">
      <div class="w3-xxlarge" style="line-height:3rem">
        <hr style="border: 1px dashed #5e5d5e">
        An experience you'd expect from a professional tool.
      </div>

      <div class="w3-margin-top">
        Opinionated and designed for daily use.
        <hr style="border: 1px dashed #5e5d5e">
      </div>

    </div>

    <div class="home-second w3-margin-top">
      <div class="inner">
        <div class="home-tag" style="color:#5e6ad2;font-weight: bold;">
           &lt; 100ms
        </div>
        <div class="home-title">
          Built for speed
        </div>
        <div class="home-description">
          Synchronized in real-time across all users. No spinners or waiting.
        </div>
      </div>

      <div class="inner">
        <div class="home-tag">
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#5E6AD2"></rect><path d="M9.44531 16.9801C10.6882 16.9801 11.7124 15.9609 11.7124 14.7031V13.7287H13.0795V14.7031C13.0795 15.9609 14.0938 16.9801 15.3565 16.9801C16.5994 16.9801 17.6186 15.9609 17.6236 14.7031C17.6335 13.4503 16.5994 12.4361 15.3565 12.4361H14.3771V11.0639H15.3565C16.5994 11.0639 17.6186 10.0497 17.6236 8.78693C17.6335 7.53906 16.5994 6.51989 15.3565 6.51989C14.0938 6.51989 13.0795 7.53906 13.0795 8.78693V9.77131H11.7124V8.78693C11.7124 7.53906 10.6882 6.51989 9.44531 6.51989C8.17756 6.51989 7.15838 7.53906 7.16335 8.78693C7.1733 10.0497 8.17756 11.0639 9.44531 11.0639H10.4148V12.4361H9.44531C8.17756 12.4361 7.15838 13.4503 7.16335 14.7031C7.1733 15.9609 8.17756 16.9801 9.44531 16.9801ZM9.44531 9.77131C8.89347 9.77131 8.45597 9.33381 8.46094 8.78693C8.46591 8.25497 8.89347 7.81747 9.44531 7.81747C9.9723 7.81747 10.4148 8.25497 10.4148 8.78693V9.77131H9.44531ZM9.44531 15.6825C8.89347 15.6825 8.45597 15.245 8.46094 14.7031C8.46591 14.1662 8.89347 13.7287 9.44531 13.7287H10.4148V14.7031C10.4098 15.245 9.9723 15.6825 9.44531 15.6825ZM14.3771 9.77131V8.78693C14.3722 8.25497 14.8097 7.81747 15.3565 7.81747C15.8835 7.81747 16.321 8.25497 16.331 8.78693C16.3359 9.33381 15.8835 9.77131 15.3565 9.77131H14.3771ZM15.3565 15.6825C14.8097 15.6825 14.3771 15.245 14.3771 14.7031V13.7287H15.3565C15.8835 13.7287 16.321 14.1662 16.331 14.7031C16.3359 15.245 15.8835 15.6825 15.3565 15.6825ZM11.7124 12.4361V11.0639H13.0795V12.4361H11.7124Z" fill="#5E6AD2"></path></svg>
        </div>
        <div class="home-title">
          Keyboard first design <span class="soon">• Soon</span>
        </div>
        <div class="home-description">
          Optimized for efficiency with extensive keyboard shortcuts.
        </div>
      </div>

      <div class="inner">
        <div class="home-tag">
           <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.1667 0H1.83333C1.3471 0 0.880788 0.193154 0.536971 0.536971C0.193154 0.880788 0 1.3471 0 1.83333L0 20.1667C0 20.6529 0.193154 21.1192 0.536971 21.463C0.880788 21.8068 1.3471 22 1.83333 22H20.1667C20.6529 22 21.1192 21.8068 21.463 21.463C21.8068 21.1192 22 20.6529 22 20.1667V1.83333C22 1.3471 21.8068 0.880788 21.463 0.536971C21.1192 0.193154 20.6529 0 20.1667 0V0ZM13.75 2.29167V19.7083C13.75 19.8299 13.7017 19.9465 13.6158 20.0324C13.5298 20.1184 13.4132 20.1667 13.2917 20.1667H8.70833C8.58678 20.1667 8.4702 20.1184 8.38424 20.0324C8.29829 19.9465 8.25 19.8299 8.25 19.7083V2.29167C8.25 2.17011 8.29829 2.05353 8.38424 1.96758C8.4702 1.88162 8.58678 1.83333 8.70833 1.83333H13.2917C13.4132 1.83333 13.5298 1.88162 13.6158 1.96758C13.7017 2.05353 13.75 2.17011 13.75 2.29167ZM2.29167 1.83333H5.95833C6.07989 1.83333 6.19647 1.88162 6.28242 1.96758C6.36838 2.05353 6.41667 2.17011 6.41667 2.29167V19.7083C6.41667 19.8299 6.36838 19.9465 6.28242 20.0324C6.19647 20.1184 6.07989 20.1667 5.95833 20.1667H2.29167C2.17011 20.1667 2.05353 20.1184 1.96758 20.0324C1.88162 19.9465 1.83333 19.8299 1.83333 19.7083V2.29167C1.83333 2.17011 1.88162 2.05353 1.96758 1.96758C2.05353 1.88162 2.17011 1.83333 2.29167 1.83333V1.83333ZM19.7083 20.1667H16.0417C15.9201 20.1667 15.8035 20.1184 15.7176 20.0324C15.6316 19.9465 15.5833 19.8299 15.5833 19.7083V2.29167C15.5833 2.17011 15.6316 2.05353 15.7176 1.96758C15.8035 1.88162 15.9201 1.83333 16.0417 1.83333H19.7083C19.8299 1.83333 19.9465 1.88162 20.0324 1.96758C20.1184 2.05353 20.1667 2.17011 20.1667 2.29167V19.7083C20.1667 19.8299 20.1184 19.9465 20.0324 20.0324C19.9465 20.1184 19.8299 20.1667 19.7083 20.1667Z" fill="#5E6AD2"></path></svg>
        </div>
        <div class="home-title">
          For software teams
        </div>
        <div class="home-description">
          Created by software people for software product teams.
        </div>
      </div>

      <div class="inner">
        <div class="home-tag">
           <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.2571 6.97431C17.082 7.55418 17.7315 8.34969 18.1347 9.27384C18.2167 9.44765 18.3492 9.59267 18.5149 9.6899C18.6806 9.78712 18.8719 9.83203 19.0636 9.81873C19.7007 9.79284 20.334 9.92915 20.9041 10.2149C21.4741 10.5006 21.9623 10.9264 22.3229 11.4524C22.7603 12.0827 22.99 12.8338 22.9797 13.6009C23.0135 14.5352 22.6764 15.4448 22.0419 16.1314C21.8616 16.3187 21.7619 16.5692 21.7641 16.8292C21.7664 17.0892 21.8704 17.338 22.0539 17.5221C22.1502 17.617 22.2645 17.6916 22.3901 17.7413C22.5158 17.7911 22.6501 17.8151 22.7852 17.8118C22.9203 17.8085 23.0534 17.7781 23.1764 17.7223C23.2995 17.6666 23.4101 17.5866 23.5016 17.4871C24.4527 16.479 24.9815 15.1449 24.9793 13.7589C25.0245 12.2946 24.5105 10.8681 23.5416 9.76924C22.5727 8.67039 21.2218 7.98169 19.7634 7.84313C19.7244 7.83935 19.6869 7.82653 19.6538 7.80571C19.6206 7.78488 19.5928 7.75662 19.5725 7.72316C18.8868 6.5872 17.9204 5.64681 16.7661 4.99246C15.6119 4.33811 14.3086 3.99183 12.9818 3.98693C12.2212 3.98663 11.4649 4.10089 10.7383 4.32586C10.0874 4.52582 9.93144 5.17069 10.3614 5.82555C10.473 6.00076 10.6408 6.13298 10.8372 6.2007C11.0336 6.26842 11.2472 6.26763 11.4431 6.19847C12.2544 5.97597 13.1039 5.9301 13.9343 6.06394C14.7648 6.19778 15.5569 6.50822 16.2571 6.97431Z" fill="#5E6AD2"></path><path d="M5.7955 17.3751C5.00229 17.3604 4.23722 17.0786 3.62395 16.5753C3.39985 16.337 3.22742 16.0549 3.11748 15.7467C3.00755 15.4386 2.96247 15.1111 2.98508 14.7847C2.98535 14.099 3.2578 13.4414 3.74258 12.9564C4.22736 12.4714 4.88483 12.1987 5.57055 12.1982C5.7502 12.1984 5.92938 12.2164 6.10544 12.2522C6.24584 12.2823 6.39112 12.2815 6.53115 12.2497C6.67119 12.2179 6.80261 12.156 6.91627 12.0682C7.03021 11.9809 7.12401 11.8701 7.19129 11.7433C7.25857 11.6165 7.29776 11.4767 7.30619 11.3334C7.32019 11.1094 7.32519 10.8275 7.32119 10.6085C7.31219 10.1086 7.34318 9.87569 7.06024 9.59275C6.94009 9.47246 6.78973 9.38679 6.62499 9.34474C6.46025 9.30269 6.28723 9.30583 6.12412 9.35382C5.96102 9.40181 5.81387 9.49288 5.69815 9.61744C5.58244 9.74201 5.50244 9.89546 5.46657 10.0617V10.0806C5.4597 10.1143 5.4418 10.1446 5.41572 10.1669C5.38964 10.1892 5.35687 10.2021 5.3226 10.2036C4.56707 10.248 3.83383 10.4763 3.18667 10.8688C2.53952 11.2612 1.99805 11.8058 1.60937 12.4552C1.17024 13.194 0.953621 14.0438 0.985495 14.9027C0.973554 15.4756 1.07668 16.0451 1.28877 16.5775C1.50086 17.1098 1.8176 17.5942 2.22024 18.002C3.20581 18.8757 4.4735 19.3645 5.7905 19.3787H14.4237C14.6214 19.3787 14.8147 19.32 14.9791 19.2102C15.1434 19.1003 15.2716 18.9442 15.3472 18.7615C15.4229 18.5788 15.4427 18.3779 15.4041 18.1839C15.3655 17.99 15.2704 17.8119 15.1306 17.6721C14.9431 17.4846 14.6889 17.3792 14.4237 17.3791L5.7955 17.3751Z" fill="#5E6AD2"></path><path d="M23.2741 23.6898C23.4627 23.8719 23.7152 23.9727 23.9774 23.9704C24.2395 23.9682 24.4903 23.863 24.6757 23.6776C24.861 23.4923 24.9662 23.2415 24.9684 22.9794C24.9707 22.7172 24.87 22.4647 24.6878 22.2761L2.69237 0.280654C2.50381 0.0985335 2.25126 -0.00224015 1.98912 3.77948e-05C1.72697 0.00231574 1.47621 0.107463 1.29084 0.292833C1.10547 0.478203 1.00033 0.728963 0.998047 0.991106C0.995769 1.25325 1.09654 1.5058 1.27866 1.69436L23.2741 23.6898Z" fill="#5E6AD2"></path></svg>
        </div>
        <div class="home-title">
          Works offline <span class="soon"> • Soon</span>
        </div>
        <div class="home-description">
          Access and make changes with or without internet access.
        </div>
      </div>

      <div class="inner">
        <div class="home-tag">
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4366 11.959C11.4371 9.56484 12.201 7.23323 13.6174 5.30302C15.0338 3.37282 17.0289 1.94461 19.3126 1.22599C17.6278 0.696766 15.842 0.571646 14.0998 0.860751C12.3575 1.14986 10.7079 1.84506 9.28422 2.89011C7.86059 3.93516 6.70298 5.3007 5.90508 6.87621C5.10718 8.45172 4.69141 10.193 4.69141 11.959C4.69141 13.725 5.10718 15.4662 5.90508 17.0418C6.70298 18.6173 7.86059 19.9828 9.28422 21.0279C10.7079 22.0729 12.3575 22.7681 14.0998 23.0572C15.842 23.3463 17.6278 23.2212 19.3126 22.692C17.0289 21.9734 15.0338 20.5452 13.6174 18.6149C12.201 16.6847 11.4371 14.3531 11.4366 11.959V11.959Z" stroke="#5E6AD2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
        </div>
        <div class="home-title">
          Light and dark UI <span class="soon"> • Soon</span>
        </div>
        <div class="home-description">
          We have multiple themes. Use light or dark, your choice.
        </div>
      </div>

      <div class="inner">
        <div class="home-tag">
           <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9997 11.5C17.0917 11.5002 16.1959 11.7082 15.3807 12.108C15.3181 12.1387 15.2626 12.1821 15.2178 12.2354C15.1729 12.2888 15.1397 12.351 15.1203 12.4179C15.1009 12.4849 15.0958 12.5551 15.1051 12.6242C15.1145 12.6933 15.1382 12.7596 15.1747 12.819C16.0409 14.2267 16.4995 15.8471 16.4997 17.5C16.4997 17.6326 16.5524 17.7598 16.6461 17.8536C16.7399 17.9473 16.8671 18 16.9997 18H23.4997C23.6323 18 23.7595 17.9473 23.8532 17.8536C23.947 17.7598 23.9997 17.6326 23.9997 17.5C23.9997 15.9087 23.3676 14.3826 22.2423 13.2574C21.1171 12.1321 19.591 11.5 17.9997 11.5Z" fill="#5E6AD2"></path><path d="M17.9443 11C20.0154 11 21.6943 9.32107 21.6943 7.25C21.6943 5.17893 20.0154 3.5 17.9443 3.5C15.8733 3.5 14.1943 5.17893 14.1943 7.25C14.1943 9.32107 15.8733 11 17.9443 11Z" fill="#5E6AD2"></path><path d="M7.5 9.5C10.1234 9.5 12.25 7.37335 12.25 4.75C12.25 2.12665 10.1234 0 7.5 0C4.87665 0 2.75 2.12665 2.75 4.75C2.75 7.37335 4.87665 9.5 7.5 9.5Z" fill="#5E6AD2"></path><path d="M15 17.5C15 15.5109 14.2098 13.6032 12.8033 12.1967C11.3968 10.7902 9.48912 10 7.5 10C5.51088 10 3.60322 10.7902 2.1967 12.1967C0.790176 13.6032 0 15.5109 0 17.5C0 17.6326 0.0526784 17.7598 0.146447 17.8536C0.240215 17.9473 0.367392 18 0.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5Z" fill="#5E6AD2"></path></svg>
        </div>
        <div class="home-title">
          Multiple teams
        </div>
        <div class="home-description">
          Have all your teams in one shared workspace.
        </div>
      </div>

    </div>

    <br><br><br>

    <div class="w3-center" style="margin: 0 auto;max-width: 700px;">

      <img alt="logo" class="sepia" style="filter: brightness(100%)"  src="@/assets/img/single.png">

      <div class="w3-xxlarge w3-center" style="">
        Get started with Planar today.
      </div>
      <div class="">
        Planar keeps everyone aligned and working without friction. Engineers, designers, and peers – all collaborating in one tool.
      </div>

      <br><br>

      <center>
        <div class="signup-btn w3-padding-large w3-round">
          <router-link :to="{ name: 'signup' }" class="">
            Sign up for free <i class="fa fa-arrow-right"></i>
          </router-link>
        </div>
      </center>

    </div>

    <br><br><br><br><br>


    <div class="w3-padding" style="margin: 0 auto;max-width: 1000px;border-top: 1px solid #27282b">
      <div class="footer">

        <div class="">
          <img alt="logo" class="sepia" style="filter: brightness(100%)" width=25 src="@/assets/img/single.png">

          Made with <i class="fa fa-heart w3-text-red"></i> in Nigeria.
        </div>

        <div class="">
          &copy; 2020 Planar. All Rights Reserved.
        </div>

      </div>
      <br>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.footer{
  display:grid; grid-template-columns: repeat(2, 1fr);
}

.footer > div:nth-child(even) {
  text-align: right;
}

.title-1{
  font-size:4.4rem;font-weight: bold;line-height: 5.5rem;
}

.title-2{
  width: 80%;margin: 0 auto;
  margin-top: 20px;
  font-size: 1.5rem;
}

.home-first{
  font-weight: bold;
  margin: 0 auto;
  padding: 8px;
  max-width: 900px;
}

.home-second {
  display: grid;
  margin: 0 auto;
  padding: 8px;
  max-width: 1000px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 9px;
}

@media only screen and (max-width: 720px) {
  .title-1{
    font-size: 35px;
    line-height: 3.5rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
}

/*  GO FULL WIDTH BELOW 480 PIXELS */
@media only screen and (max-width: 480px) {
	.home-second, .footer{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .footer > div:nth-child(even) {
    text-align: center;
    margin-top: 8px;
  }

  .footer > div:nth-child(odd) {
    text-align: center;
    margin-top: 8px;
  }

  .title-2{
    font-size: 0.8rem;
  }

}

.home-second > div{
  background: #27282b;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 1px 1px #4A61DD;
  /* filter: blur(0.1px); */
}

.home-title{
  font-weight: bold;
}

.home-description{
  color: #8A8F98;
  font-weight:bold;
  margin-top: 8px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  /* color: #42b983; */
  text-decoration: none
}

.main-image {
  max-width: 100%;
  max-height: 400px;
  background-size: contain;
}

.signup-btn{
  background-color: #4A61DD;
  color: white;
  display: inline-block;
  margin: 0 auto;
}

/*  GO FULL WIDTH BELOW 480 PIXELS */
@media only screen and (max-width: 480px) {
	.title-1{
    font-size: 25px;
    line-height: 2rem;
    font-weight: bold
  }

  .title-2{
    width: 100%;
    margin-top: 15px;
  }
}

.soon{
  color: orange;
  text-transform: capitalize;
}
</style>
